var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGanttDowntime01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 27,
    viewBox: "0 0 14 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1143",
    "data-name": "Group 1143",
    transform: "translate(-357 -307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_8",
    "data-name": "Polygon 8",
    d: "M7,0l7,5H0Z",
    transform: "translate(357 329)",
    fill: "#f86a6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_7",
    "data-name": "Polygon 7",
    d: "M7,0l7,5H0Z",
    transform: "translate(371 312) rotate(180)",
    fill: "#f86a6a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGanttDowntime01);
export default __webpack_public_path__ + "static/media/gantt_downtime_01.f16be1150ea316b95db3608739230105.svg";
export { ForwardRef as ReactComponent };